<script lang="ts">
	interface Props {
		rate: string;
		isMonthly?: boolean;
		strikeThrough?: boolean;
		suffix?: string;
	}

	let { rate, isMonthly = false, strikeThrough = false, suffix }: Props = $props();

	let [dollars, cents] = $derived(rate.split('.'));
	let textStyle = $derived(strikeThrough ? 'text-stone-300' : 'font-semibold');
</script>

<div class="relative inline-flex items-end gap-x-[-0.5ch] {textStyle}">
	<span class="text-[40px]/[110%] tracking-[-.4px]">
		{dollars}
	</span>
	{#if cents && cents.length > 1}
		<span class="text-[18px] tracking-[-.2px]">.{cents}</span>
	{/if}

	{#if isMonthly}
		<span class="text-[18px]/[140%] font-normal">/month</span>
	{/if}

	{#if suffix && suffix.length > 0}
		<span class="ml-[0.25ch] whitespace-nowrap text-[18px]/[140%] font-normal">{suffix}</span>
	{/if}

	{#if strikeThrough}
		<div class="absolute left-[-5px] right-[-5px] top-[50%] -mt-[1px] h-[2px] bg-stone-300"></div>
	{/if}
</div>
